var _rect, _g, _path, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 2,
    width: 44,
    height: 56,
    rx: 10,
    transform: "rotate(20 57 2)",
    fill: "url(#paint0_linear_3944_156732)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3944_156732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 56,
    height: 68,
    rx: 10,
    fill: "url(#paint1_linear_3944_156732)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.15,
    y: 16.15,
    width: 55.7,
    height: 67.7,
    rx: 9.85,
    stroke: "url(#paint2_linear_3944_156732)",
    strokeWidth: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1351 61.7067C55.1351 55.8304 59.9632 51.0667 65.9189 51.0667C71.8746 51.0667 76.7027 55.8304 76.7027 61.7067C76.7027 67.583 71.8746 72.3467 65.9189 72.3467C59.9632 72.3467 55.1351 67.583 55.1351 61.7067ZM65.9189 46C57.1271 46 50 53.0321 50 61.7067C50 70.3812 57.1271 77.4133 65.9189 77.4133C69.2558 77.4133 72.353 76.4003 74.9116 74.6689L83.6168 83.258C84.6195 84.2473 86.2451 84.2473 87.2478 83.258C88.2505 82.2687 88.2505 80.6646 87.2478 79.6753L78.6262 71.1686C80.6421 68.537 81.8378 65.2596 81.8378 61.7067C81.8378 53.0321 74.7107 46 65.9189 46Z",
    fill: "url(#paint3_linear_3944_156732)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 36,
    height: 5.4,
    rx: 2.7,
    fill: "url(#paint4_linear_3944_156732)",
    stroke: "url(#paint5_linear_3944_156732)",
    strokeWidth: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 37,
    width: 28,
    height: 5.4,
    rx: 2.7,
    fill: "url(#paint6_linear_3944_156732)",
    stroke: "url(#paint7_linear_3944_156732)",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3944_156732",
    x: 16,
    y: 10,
    width: 68,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3944_156732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3944_156732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3944_156732",
    x1: 79,
    y1: -3.60003,
    x2: 79,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C33F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3944_156732",
    x1: 16.824,
    y1: 52.4558,
    x2: 97.1853,
    y2: 58.1053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F3FF",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3944_156732",
    x1: 16.5,
    y1: 10.5,
    x2: 60.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3944_156732",
    x1: 47.8889,
    y1: 47.5205,
    x2: 102.778,
    y2: 85.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8BAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3944_156732",
    x1: 28,
    y1: 26,
    x2: 31.4569,
    y2: 43.2284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3944_156732",
    x1: 50,
    y1: 26,
    x2: 50,
    y2: 31.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3944_156732",
    x1: 28.8889,
    y1: 37,
    x2: 33.2239,
    y2: 53.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3944_156732",
    x1: 46,
    y1: 37,
    x2: 46,
    y2: 42.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPlaceholder);
export default __webpack_public_path__ + "static/media/waiting-placeholder.89488386e3e728bf139ca01d6554122e.svg";
export { ForwardRef as ReactComponent };